import { defineComponent } from "vue";
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
export default defineComponent({
    components: {
        BarChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },
    setup: function (props) {
        const options = {
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: props.title,
                    font: {
                        family: "'Exo 2', sans-serif",
                        size: 14
                    },
                    color: "rgb(255, 255, 255)"
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxTicksLimit: 10,
                        color: "rgb(255, 255, 255)"
                    },
                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        maxTicksLimit: 10,
                        color: "rgb(255, 255, 255)"
                    }
                }
            }
        };
        const chartData = {
            labels: props.data.labels,
            datasets: [{
                    barTickness: 6,
                    maxBarThickness: 8,
                    minbarLength: 2,
                    data: props.data.values,
                    backgroundColor: "rgb(1, 151, 246)",
                    hoverBackgroundColor: "rgb(217, 4, 41)"
                }]
        };
        return {
            options,
            chartData
        };
    }
});
